import { Button, Tabs } from "antd";
import React from "react";
import UserActiveTable from "../../components/table/userModule/UsersTable";

function Users() {
  return (
    <section>
      <div className="flex justify-between">
        <div>
          <h2> Users</h2>
        </div>
        <div className="space-x-4 flex items-center">
          <Button type="default" className="rounded-md bg-black text-white">
            Generate Report
          </Button>
        </div>
      </div>

      <div className="my-10">
       

        {/* antd v6 removed Tabs.TabPane; panes are declared as `items`. */}
        <Tabs
          defaultActiveKey="1"
          items={[
            {key: "1", label: "All Users", children: <UserActiveTable />},
            {key: "2", label: "Active Users", children: <UserActiveTable />},
            {key: "3", label: "In Active Users", children: <UserActiveTable />},
          ]}
        />


      </div>
    </section>
  );
}

export default Users;
